import React, {memo} from 'react'
import {handleCompanyStatusChange, handleProdAppStatusChange,
    handleProdLvStatusChange, getOrganisations,
    saveNewCompanyData} from "../../API/organisation";
import $ from 'jquery';
import 'datatables.net';
import {Col, Container, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import "../../index.css";
import "../../Styles/OrganisationManagement/Organisation.css";
import validator from "validator/es";
import NewOrganisationModal from "./NewOrganisationModal";
import {getOut} from "../../Utils/Common";


class Organisation extends React.Component {

    constructor(props) {
        super(props);
        this.handleNewCompanySave = this.handleNewCompanySave.bind(this);
        this.resetState = this.resetState.bind(this);
        this.updateState = this.updateState.bind(this);
        this.checkValidation = this.checkValidation.bind(this);
        this.handleCountryNameChange = this.handleCountryNameChange.bind(this);
        this.handleStreetNumberChange = this.handleStreetNumberChange.bind(this);
        this.handlePostCodeChange = this.handlePostCodeChange.bind(this);
        this.handleOrganisationNameChange = this.handleOrganisationNameChange.bind(this);
        this.handleCityNameChange = this.handleCityNameChange.bind(this);
        this.handleStreetNameChange= this.handleStreetNameChange.bind(this);

        this.handleProductChange= this.handleProductChange.bind(this);

        this.setErrMessg();
        this.state = {
            displayStatus: false,
            addNewOrganisationModalShow: false,
            tableCheckbox: false,
            editOrganisationData: {
                items: {
                    cm_n: "",
                    cm_em: "",
                    cm_logo: " ",
                    cm_cit: "",
                    cm_cou: "",
                    cm_pos: "",
                    cm_snm: "",
                    cm_snr: "",
                    fn: "",
                    ln: "",
                    em: "",
                    co: "",
                    ge: "M",
                    cm_st_lv:false,
                    cm_st_app:false
                }
            }
        }
    }

    createNewOrganisation = async () => {
        const items = {
            cm_n: "",
            cm_em: "",
            cm_logo: " ",
            cm_cit: "",
            cm_cou: "",
            cm_pos: "",
            cm_snm: "",
            cm_snr: "",
            fn: "",
            ln: "",
            em: "",
            co: "",
            ge: "M",
            cm_st_lv:false,
            cm_st_app:false
        };
        this.setState({editOrganisationData: {items}});
        this.setState({addNewOrganisationModalShow: true});
        this.setErrMessg()
    };


    setErrMessg() {
        this.setState({
            errorMessageOrganisationName: "",
            errorMessageCityName: "",
            errorMessageStreetName: "",
            errorMessagePostCode: "",
            errorMessageStreetNumber: "",
            errorMessageCountryName: "",
            errorMessageFirstName: "",
            errorMessageLastName: "",
            errorMessageEMail: "",
            errorMessageContactNumber: "",
        })
    }

    async componentDidMount() {

        const organisationsAPIData = await getOrganisations();
        let orgdatas = Object.values(organisationsAPIData).map(o =>

            <tr key={o.cm_id}>
                <td><input
                    onChange={e => handleCompanyStatusChange(e, o)}
                    className="organisationCheckbox"
                    id="checkbox"
                    type="checkbox"
                    defaultChecked={o.cm_st}/></td>
                <td>{o.cm_n}</td>
                <td>{o.tot_admins}</td>
                <td><input
                    onChange={e => {handleProdLvStatusChange(e, o);
                    //this.setState(organisationData:'');
                    }
                    }
                    className="organisationCheckbox"
                    id="checkbox_st_cm_lvanalyse"
                    type="checkbox"
                    defaultChecked={o.cm_st_lv}/></td>
                <td>{o.tot_calcul}</td>
                <td><input
                    onChange={e => handleProdAppStatusChange(e, o)}
                    className="organisationCheckbox"
                    id="checkbox_st_cm_app"
                    type="checkbox"
                    defaultChecked={o.cm_st_app}/></td>
                <td>{o.cm_appMonteur}</td>
                <td>{o.cm_appPl}</td>
            </tr>
        );

        this.setState({
            organisationData: orgdatas
        });


        // Initialises the DataTable for our User Management - Super Admin.
        $("#organisationManagementTable").DataTable({
            "aLengthMenu": [[3, 5, 10, -1], [3, 5, 10, "All"]],
            "pageLength": 3,   // Shows three rows by default.
            "dom": 'frtilp',
            "language": {
                fontcolor: 'white',
                url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json'// German Language - DataTable Plugin
            },
            "oLanguage": {
                "sSearch": "",
                searchPlaceholder: "Suchen"
            },
            "columnDefs": [
                {"className": "dt-center", "targets": "_all"} // Shows data in table columns - centered.
            ],
        });

        let _ = this
        $("#create-organisation-button").click(function () {
            _.createNewOrganisation();
        });

    }


    handleOrganisationNameChange(newChangeData) {
        let messageOrganisationName = null;
        newChangeData = newChangeData.trim()
        if (newChangeData.length === 0) {
            messageOrganisationName = "Bitte eine gültige Firmenname eintragen";
        } else {
            messageOrganisationName = "";
        }
        let createONDataCopy = this.state.editOrganisationData;
        createONDataCopy.items["cm_n"] = newChangeData
        this.setState({editOrganisationData: createONDataCopy, errorMessageOrganisationName: messageOrganisationName})

    }

    handleCityNameChange(newChangeData) {
        let messageStadt = null;
        newChangeData = newChangeData.trim()
        if (newChangeData.length !== 0) {
            if ((/\d/.test(newChangeData))) {
                messageStadt = "Bitte eine gültige Stadt eintragen";
            } else if (!(/\d/.test(newChangeData))) {
                messageStadt = "";
            }
        } else if (newChangeData.length === 0) {
            messageStadt = "Bitte eine gültige Stadt eintragen";
        }
        let createSDataCopy = this.state.editOrganisationData;
        createSDataCopy.items["cm_cit"] = newChangeData
        this.setState({editOrganisationData: createSDataCopy, errorMessageCityName: messageStadt})
    }

    handleStreetNameChange(newChangeData) {
        let messageStreet = null;
        newChangeData = newChangeData.trim()
        if (newChangeData.length !== 0) {
            if ((/\d/.test(newChangeData))) {
                messageStreet = "Bitte eine gültige Straße eintrage";
            } else if (!(/\d/.test(newChangeData))) {
                messageStreet = "";
            }
        } else if (newChangeData.length === 0) {
            messageStreet = "Bitte eine gültige Straße eintrage";
        }
        let createSDataCopy = this.state.editOrganisationData;
        createSDataCopy.items["cm_snm"] = newChangeData
        this.setState({editOrganisationData: createSDataCopy, errorMessageStreetName: messageStreet})
    }

    handlePostCodeChange(newChangeData) {
        let messagePostzahl = null;
        if (!validator.isNumeric(newChangeData, {no_symbols: true})) {
            messagePostzahl = "Bitte eine gültige Postleitzahl eintragen";
        } else if (validator.isNumeric(newChangeData, {no_symbols: true})) {
            messagePostzahl = "";
        }
        let createSDataCopy = this.state.editOrganisationData;
        createSDataCopy.items["cm_pos"] = newChangeData
        this.setState({editOrganisationData: createSDataCopy, errorMessagePostCode: messagePostzahl})
    }


    handleStreetNumberChange(newChangeData) {
        let messageStreetNumber = null;
        if (!validator.isAlphanumeric(newChangeData, 'de-DE')) {
            messageStreetNumber = "Bitte eine gültige Strße Nummer eintragen";
        } else if (validator.isAlphanumeric(newChangeData, 'de-DE')) {
            messageStreetNumber = "";
        }
        let createSNDataCopy = this.state.editOrganisationData;
        createSNDataCopy.items["cm_snr"] = newChangeData
        this.setState({editOrganisationData: createSNDataCopy, errorMessageStreetNumber: messageStreetNumber})
    }

    handleCountryNameChange(newChangeData) {
        let messageCountryName = null;
        newChangeData = newChangeData.trim()
        if (!validator.isAlpha(newChangeData, 'de-DE', {ignore: ' '})) {
            messageCountryName = "Bitte eine gültige Land eintragen";
        } else if (validator.isAlpha(newChangeData, 'de-DE', {ignore: ' '})) {
            messageCountryName = "";
        }
        let createCNDataCopy = this.state.editOrganisationData;
        createCNDataCopy.items["cm_cou"] = newChangeData
        this.setState({editOrganisationData: createCNDataCopy, errorMessageCountryName: messageCountryName})
    }

    handleProductChange(e,type){
        let createCProdDataCopy = this.state.editOrganisationData;
        if (type=='lv'){createCProdDataCopy.items['cm_st_lv']=e.target.checked}
        else if (type=='app'){createCProdDataCopy.items['cm_st_app']=e.target.checked}
        this.setState({editOrganisationData: createCProdDataCopy, errorMessageProd: ''})
    }


    checkValidation() {
        let createcopy = this.state.editOrganisationData;
        return createcopy.items["fn"] !== "" &&
            createcopy.items["ln"] !== "" &&
            createcopy.items["em"] !== "" &&
            createcopy.items["co"] !== "" &&
            createcopy.items["cm_n"] !== "" &&
            createcopy.items["cm_cit"] !== "" &&
            createcopy.items["cm_cou"] !== "" &&
            createcopy.items["cm_pos"] !== "" &&
            createcopy.items["cm_snm"] !== "" &&
            createcopy.items["cm_snr"] !== ""

            &&(createcopy.items['cm_st_lv'] !== false
            ||createcopy.items['cm_st_app'] !== false)



            && (this.state.errorMessageEMail === "")
            && (this.state.errorMessageContactNumber === "")
        && (this.state.errorMessageCountryName === "")
        && (this.state.errorMessageStreetNumber === "")
        &&(this.state.errorMessageStreetName === "")
        && (this.state.errorMessagePostCode === "")
        && (this.state.errorMessageCityName === "")
        && (this.state.errorMessageOrganisationName === "")
    }


    async handleNewCompanySave() {
        let validationError = this.checkValidation();
        if (validationError === false) {
            alert("Das Formular ist ungültig. Bitte füllen Sie alle Angaben aus.")
        } else {
            this.setState({addNewOrganisationModalShow: false});
            let result = await saveNewCompanyData(JSON.parse(JSON.stringify(this.state.editOrganisationData.items)));
            if ((JSON.stringify(result)).message === `${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`) {
            getOut(`${process.env.REACT_APP_BACKEND_INVALIDTOKEN}`);
        }
            console.log(result.message)
            setTimeout(function () {
                window.location.reload(0.5);
            }, 500);
        }
    }

    updateState(dataCopy, mydict) {
        mydict['editOrganisationData'] = dataCopy;
        this.setState(mydict);
    }

    resetState(mydict) {
        this.setState(mydict);
    }

    render() {
        return (
            <>
                <div className="handwai-dark organisationBorerStyle">

                    <Container fluid>

                        {/* A Button for new organisation - modal. */}
                        <Row>
                            <Col md={{span: 1, offset: 11}}>
                                <button id="create-organisation-button" className="btn handwai-btn createOrganisation"
                                ><FontAwesomeIcon icon={faPlus}/> Neu Organisation
                                </button>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <table id="organisationManagementTable" className="table">

                                    <thead>
                                    <tr>
                                        <th data-sortable="true" data-searchable="true">Status</th>
                                        <th data-sortable="true" data-searchable="true">Organisation</th>
                                        <th data-sortable="true" data-searchable="true">Anzahl Admins</th>
                                        <th data-sortable="true" data-searchable="true">LV-Analyse</th>
                                        <th data-sortable="true" data-searchable="true">LV-Kalkulatoren</th>
                                        <th data-sortable="true" data-searchable="true">APP</th>
                                        <th data-sortable="true" data-searchable="true">APP-Monteure</th>
                                        <th data-sortable="true" data-searchable="true">APP-PLs</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.organisationData}
                                    </tbody>
                                </table>

                            </Col>
                        </Row>

                    </Container>
                </div>


                {/* A Modal for existing user where we can edit the information. */}
                <NewOrganisationModal props={this.state} changeState={this.updateState} resetState={this.resetState}
                                      handleCountryNameChange={this.handleCountryNameChange}
                                      handleCityNameChange={this.handleCityNameChange}
                                      handleStreetNumberChange={this.handleStreetNumberChange}
                                      handlePostCodeChange={this.handlePostCodeChange}
                                      handleOrganisationNameChange={this.handleOrganisationNameChange}
                                      handleNewCompanySave={this.handleNewCompanySave}
                                      handleStreetNameChange={this.handleStreetNameChange}
                                      handleProductChange={this.handleProductChange}
                checkValidation={this.checkValidation}/>


            </>
        );
    }
}


export default memo(Organisation);